export function getApparelTabs(links) {
  const {
    sizeChart, careGuide, dimensions, handling, productSpecification,
  } = links || {};
  const merchandiseTabs = [];
  if (productSpecification?.length) {
    merchandiseTabs.push({ id: "overview", title: "Overview" });
  }
  if (sizeChart?.length) {
    merchandiseTabs.push({ id: "size_chart", title: "Size Chart" });
  }
  if (careGuide?.length) {
    merchandiseTabs.push({ id: "care_guide", title: "Care Guide" });
  }
  if (dimensions?.length) {
    merchandiseTabs.push({ id: "dimensions", title: "Dimensions" });
  }
  if (handling?.length) {
    merchandiseTabs.push({ id: "handling", title: "Handling" });
  }
  return merchandiseTabs;
}
